// plugins/xlsx.js

import Vue from "vue";
import * as XLSX from "xlsx";

// Assign XLSX to Vue's prototype
Vue.prototype.$xlsx = XLSX;
